<template>
    <div style="min-height: calc(100vh - 100px); ">
        <div v-if="!noResult">
            <section class="course-descripion-banner-section gradiant-banner" v-if="courseData">
                <div class="container">
                    <div class="course-descripion-banner-wrapper">
                        <b-row>
                            <b-col cols="12" md="6">
                                <div class="course-descripion-banner-left">
                                    <h5 class="heading text-capitalize">{{ courseData.name }}</h5>
                                    <div class="status">
                                        <div class="conductedby">
                                            <img
                                                    :src="courseData.profile_photo"
                                                    alt
                                                    srcset
                                                    v-if="courseData.profile_photo"
                                            />
                                            <img
                                                    src="https://placeimg.com/50/50/person"
                                                    alt
                                                    srcset
                                                    v-else
                                            />
                                            <div class="fl">
                                                <span>Conducted by</span>
                                                <div @click="goToTeacher()">
                                                    <p>{{ courseData.teacher_name }}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <wishlist-button
                                                v-if="getUserRole !== 'teacher' && !isSubscribed"
                                                :course-name="courseData.name"
                                                :course-id="courseData.course_id"
                                        />
                                        <cart-button
                                                v-if="
                      !isSubscribed ^ (parseInt(courseData.price, 10) === 0) &&
                        getUserRole !== 'teacher'
                    "
                                                :course-id="courseData.course_id"
                                                :course-name="courseData.name"
                                                :price="courseData.price"
                                                :image-url="courseData.course_properties.imgUrl"
                                                :course-type="courseType"
                                        />
                                        <div
                                                class="time cart-button"
                                                v-if="
                      isAuthenticated &&
                        getUserRole === 'teacher' &&
                        isSubscribed
                    "
                                                @click="goToEdit"
                                        >
                                            <div class="vl">
                                                <font-awesome-icon
                                                        :icon="['far', 'edit']"
                                                />
                                                <p>Edit<br/>Course</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-col>
                            <b-col cols="12" md="6" class="p-0">
                                <div class="course-descripion-banner-right">
                                    <div class="course-descripion-banner-video">
                                        <video-modal
                                                v-if="videoUrl"
                                                :video-url="videoUrl"
                                                :show-play-list="showPlayList"
                                                :is-subscribed="isSubscribed"
                                        />
                                        <no-course-notification v-if="!videoUrl"/>
                                        <div @click="startCourse"
                                             class="course-descripion-banner-video-img"
                                        >
                                            <!-- <font-awesome-icon icon="play-circle"></font-awesome-icon> -->

                                            <b-img
                                                    src="../../static/images/icons/playbutton.png"
                                                    class="play-button"
                                            ></b-img>
                                            <img
                                                    v-if="
                        courseData &&
                          courseData.course_properties &&
                          courseData.course_properties.imgUrl
                      "
                                                    class="coverimg"
                                                    :src="courseData.course_properties.imgUrl"
                                                    :alt="courseData.name"
                                                    srcset=""
                                            />
                                        </div>
                                        <div
                                                class="course-descripion-banner-video-img-bottom"
                                                v-if="getUserRole !== 'teacher'"
                                        >
                                            <b-button-group
                                                    v-if="!isSubscribed && courseData.price !== 0"
                                            >
                                                <b-button size="lg" pill variant="secondary">
                                                    ₹{{ courseData.price }}
                                                </b-button>
                                                <b-button
                                                        size="lg"
                                                        pill
                                                        variant="primary"
                                                        @click="goToSubscription"
                                                >
                                                    <span>Buy Now</span>
                                                    <font-awesome-icon icon="arrow-right" size="xs"/>
                                                </b-button>
                                            </b-button-group>
                                            <b-button-group v-else>
                                                <b-button
                                                        size="lg"
                                                        pill
                                                        variant="secondary"
                                                        v-if="courseData.price === 0"
                                                >
                                                    Free
                                                </b-button>
                                                <b-button size="lg" pill variant="secondary" v-else>
                                                    Subscribed
                                                </b-button>
                                                <b-button
                                                        size="lg"
                                                        pill
                                                        variant="primary"
                                                        @click="startCourse"
                                                >
                                                    <span>Get Started</span>
                                                    <font-awesome-icon icon="arrow-right" size="xs"/>
                                                </b-button>
                                            </b-button-group>
                                        </div>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </section>
            <section class="course-descripion-banner-details-section">
                <b-container>
                    <div class="course-descripion-banner-details">
                        <b-row>
                            <b-col cols="1" md="6">
                                <div class="features-list">
                                    <div class="first">
                                        <b-img
                                                src="../../static/images/icons/book-icon.png"
                                                fluid
                                                alt="Computer image"
                                        ></b-img>
                                        <div class="fl">
                                            <span>Subject</span>
                                            <span
                                                    v-if="
                        courseData &&
                          courseData.course_properties &&
                          courseData.course_properties.subject
                      "
                                            >{{ courseData.course_properties.subject }}</span
                                            >
                                        </div>
                                    </div>
                                    <div class="second">
                                        <b-img
                                                src="../../static/images/icons/clock-icon.png"
                                                fluid
                                                alt="Bulb image"
                                        ></b-img>
                                        <div class="fl">
                                            <span>Duration</span>
                                            <span>{{ courseData.course_duration }}</span>
                                        </div>
                                    </div>
                                    <course-share></course-share>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                </b-container>
            </section>
            <section>
                <b-container>
                    <b-row class="mt-5">
                        <b-col cols="12">
                            <!--<b-col :cols="courseData.videos.length > 0 ? '6' : '12'">-->
                            <b-row class="">
                                <b-col cols="6">
                                    <p>{{ courseData.description }}</p>
                                </b-col>
                                <b-col cols="6">
                                    <write-review
                                            v-if="getUserRole !== 'teacher'"
                                            :course-id="courseId"
                                            :course-name="courseData.name"
                                            :isTeacher="false"
                                            :rating="rating"
                                            :review="review"
                                            :price="courseData.price"
                                            :isSubscribed="isSubscribed"
                                    />
                                    <p v-else>{{ courseData.description }}</p>
                                </b-col>
                                <!--              <b-col cols="12 mt-3">-->
                                <!--                {{ courseData.description }}-->
                                <!--              </b-col>-->
                            </b-row>
                        </b-col>
                        <!--<b-col-->
                        <!--cols="6 p-0 course-description-playlist"-->
                        <!--v-if="courseData.videos.length > 0"-->
                        <!--&gt;-->
                        <!--<Playlist-->
                        <!--:playlist="courseData.videos"-->
                        <!--@playVideo="playVideo"-->
                        <!--:is-subscribed="isSubscribed"-->
                        <!--/>-->
                        <!--</b-col>-->
                    </b-row>
                </b-container>
            </section>
            <section class="mt-5">
                <b-container>
                    <b-row>
                        <b-col cols="6">
                            <div class="course-spec-left" v-if="courseData.course_speciality">
                                <div class="heading">Course Speciality</div>
                                <ul>
                                    <li v-for="(specs, i) in courseData.course_speciality" :key="i" class="row">
                                        <p class="col">{{ specs }}</p>
                                    </li>
                                </ul>
                            </div>
                        </b-col>
                        <b-col cols="6" v-if="teacherData.length > 0">
                            <div class="course-spec-right">
                                <div class="heading">Review</div>
<!--                                <tiny-slider-->
<!--                                        v-bind="tinySliderOptions"-->
<!--                                        :controlsText="controlsText"-->
<!--                                >-->
<!--                                    <div v-for="i in 8" :key="i">-->
<!--                                        <teacher-card-->
<!--                                                :teacher-data="teacherData[i - 1]"-->
<!--                                                v-if="teacherData[i - 1]"-->
<!--                                        />-->
<!--                                    </div>-->
<!--                                </tiny-slider>-->

                                <b-list-group class="review-list">
                                    <b-list-group-item v-for="review in reviews" :key="review.review_title" class="review-list-item d-flex">
                                        <b-badge variant="primary" pill>
                                            {{ review.rating }}.0
                                        </b-badge>
                                        <div class="left">
                                            <h6>{{ review.review_title }}</h6>
                                            <small class="mb-3">By {{ review.user_name }}</small>
                                            <p>{{ review.review_text }}</p>
                                        </div>
                                    </b-list-group-item>
                                </b-list-group>
                            </div>
                        </b-col>
                    </b-row>
                </b-container>
            </section>
            <about-teacher :teacher-id="courseData.teacher_id"></about-teacher>
<!--            <Testimonials :reviews="reviews" v-if="reviews.length > 0"></Testimonials>-->
        </div>
        <div v-if="noResult">
            <loader></loader>
        </div>
    </div>
</template>

<script>
    import VideoModal from "../components/modals/VideoModal";
    import TeacherCard from "../components/Templates/TeacherCard";
    import Playlist from "../components/Templates/Playlist";
    import {store} from "../store/store";
    import {mapGetters} from "vuex";
    import Testimonials from "../components/Testimonials/Testimonials";
    import {videoApi} from "../services/videoApi";
    import {teacherApi} from "../services/teacherApi";
    import {customerApi} from "../services/customerApi";
    import NoCourseNotification from "../components/modals/NoCourseNotification";
    import WriteReview from "../components/Templates/WriteReview";
    import WishlistButton from "../components/Templates/WishlistButton";
    import CartButton from "../components/buttons/CartButton";
    import Loader from "../components/Loader";
    import { commonFunctions } from "../Commonjs/commonFunctions";
    import CourseShare from "../components/Templates/CourseShare";
    import AboutTeacher from "../components/Templates/AboutTeacher";

    export default {
        components: {
            AboutTeacher,
            CourseShare,
            Loader,
            CartButton,
            WishlistButton,
            NoCourseNotification,
            TeacherCard,
            VideoModal,
            Playlist,
            Testimonials,
            WriteReview
        },
        data: function () {
            return {
                courseId: "",
                tinySliderOptions: {
                    mouseDrag: true,
                    loop: false,
                    items: 1,
                    gutter: 20,
                    swipeAngle: 45,
                    controls: false,
                    nav: true,
                    responsive: {
                        768: {
                            items: 2,
                            gutter: 0
                        },
                        1200: {
                            items: 3,
                            gutter: 5
                        }
                    }
                },
                courseData: {},
                teacherData: [],
                videoUrl: "",
                showPlayList: true,
                isSubscribed: false,
                reviews: [],
                rating: 0,
                isLiveCourse: false,
                review: {},
                courseType: "course",
                noResult: true
            };
        },
        computed: {
            ...mapGetters("user", [
                "isAuthenticated",
                "getUserDetails",
                "getUserRole",
                "getSubscribedLiveCourses",
                "getSubscribedCourses",
                "getTeacherCourses",
                "getTeacherLiveCourses",
                "getCourseStatus"
            ]),
            ...mapGetters("courses", ["getSelectedCourse"]),
            ...mapGetters("events", ["getRedirectToSubscription"]),
            ...mapGetters("teacher", ["getFollowingTeachers"]),

            controlsText() {
                const arrows = [];
                arrows.push(
                    '<img src="data:image/png;base64,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">'
                );
                arrows.push(
                    '<img src="data:image/png;base64,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">'
                );
                return arrows;
            }
        },
        mounted() {
            this.initialFunction();
            commonFunctions.ToggleNoScroll();
        },
        methods: {
            initialFunction() {
                this.courseId = this.$route.query.courseId;
                if (this.$route.query.courseType === "liveCourse") {
                    this.isLiveCourse = true;
                    this.getLiveCoursesByCourseId();
                    this.courseType = this.$route.query.courseType;
                } else {
                    this.getCourseByCourseId();
                }
                this.getReview();
                this.setIsSubscribed();
            },
            goToTeacher() {
                this.$router.push({
                    path: "/teacher",
                    query: {
                        teacherId: this.courseData.teacher_id
                    }
                });
            },
            playVideo(videoUrl) {
                this.videoUrl = videoUrl;
                this.$bvModal.show("video-modal");
            },
            goToSubscription() {
                if (this.isAuthenticated) {
                    this.$router.push({
                        name: "course_subscription",
                        path: "/course_subscription",
                        query: {
                            courseId: this.courseData.course_id,
                            isLiveCourse: this.isLiveCourse
                        }
                    });
                } else {
                    store.dispatch("events/setRedirectToSubscription", true);
                    this.$bvModal.show("modal-1");
                }
            },
            startCourse() {
                if (this.videoUrl === "") {
                    this.$bvModal.show("no-course-modal");
                } else {
                    // this.$bvModal.show("video-modal")
                    this.$router.push({
                        path: "/play_video",
                        query: {
                            course_id: this.courseId,
                            isSubscribed: this.isSubscribed
                        }
                    })
                }
            },
            getCourseByCourseId() {
                videoApi
                    .getCourseByCourseId(this.courseId)
                    .then(res => {
                        this.noResult = false;
                        this.courseData = res.data;
                        this.courseData.isLiveCourse = false;
                        store.dispatch("courses/setSelectedCourse", this.courseData);
                        this.getTeacherDetailsByCategory(res.data.category_id);
                        if (res.data.videos[0] && res.data.videos[0].video_url) {
                            this.videoUrl = res.data.videos[0].video_url;
                        }
                        const courseReviews = res.data.courseReviewResponse.courseReview;
                        for (let [key, value] of Object.entries(courseReviews)) {
                            value.forEach(review => {
                                this.reviews.push(review);
                            });
                        }
                        if (this.courseData.courseReviewResponse.courseRating) {
                            this.rating = this.courseData.courseReviewResponse.courseRating;
                        } else {
                            this.rating = 0;
                        }
                    })
                    .catch(e => {
                        console.error("api failed", e);
                    });
            },
            getTeacherDetailsByCategory(category_id) {
                teacherApi.getTeachersByCategory(category_id).then(res => {
                    if (this.isAuthenticated) {
                        res.data.forEach(teachers => {
                            this.getFollowingTeachers.forEach(teacher => {
                                if (teacher.teacher_id === teachers.teacher_id) {
                                    teachers.isFollowing = true;
                                }
                            });
                            this.teacherData.push(teachers);
                        });
                    } else {
                        this.teacherData = res.data;
                    }
                });
            },
            getLiveCoursesByCourseId() {
                videoApi
                    .getLiveCoursesByCourseId(this.courseId)
                    .then(res => {
                        this.noResult = false;
                        this.courseData = res.data;
                        this.courseData.isLiveCourse = true;
                        store.dispatch("courses/setSelectedCourse", this.courseData);
                        this.getTeacherDetailsByCategory(res.data.category_id);
                        this.setVideoUrl();
                        const courseReviews = res.data.courseReviewResponse.courseReview;
                        for (let [key, value] of Object.entries(courseReviews)) {
                            value.forEach(review => {
                                this.reviews.push(review);
                            });
                        }
                        if (this.courseData.courseReviewResponse.courseRating) {
                            this.rating = this.courseData.courseReviewResponse.courseRating;
                        } else {
                            this.rating = 0;
                        }
                    })
                    .catch(e => {
                        console.error("api failed", e);
                    });
            },
            getReview() {
                const courseData = {
                    course_id: this.courseId
                };
                customerApi
                    .editCourseReview(courseData)
                    .then(res => {
                        this.review = res.data
                            ? res.data
                            : {
                                rating: 0
                            };
                    })
                    .catch(e => {
                        this.review = {
                            rating: 0
                        };
                    });
            },
            setIsSubscribed() {
                if (this.isAuthenticated) {
                    if (this.getUserRole === "teacher") {
                        if (this.isLiveCourse) {
                            if (this.getTeacherLiveCourses.length > 0) {
                                if (
                                    this.getTeacherLiveCourses.some(
                                        courseD => courseD.course_id === this.courseId
                                    )
                                ) {
                                    this.isSubscribed = true;
                                }
                            } else if (this.getSubscribedLiveCourses.length > 0) {
                                if (
                                    this.getSubscribedLiveCourses.some(
                                        courseD => courseD.course_id === this.courseId
                                    )
                                ) {
                                    this.isSubscribed = true;
                                }
                            } else {
                                this.isSubscribed = false;
                            }
                        } else {
                            if (this.getTeacherCourses.length > 0) {
                                if (
                                    this.getTeacherCourses.some(
                                        courseD => courseD.course_id === this.courseId
                                    )
                                ) {
                                    this.isSubscribed = true;
                                }
                            } else if (this.getSubscribedCourses.length > 0) {
                                if (
                                    this.getSubscribedCourses.some(
                                        courseD => courseD.course_id === this.courseId
                                    )
                                ) {
                                    this.isSubscribed = true;
                                }
                            } else {
                                this.isSubscribed = false;
                            }
                        }
                    } else if (this.getUserRole === "student") {
                        if (this.isLiveCourse) {
                            if (this.getSubscribedLiveCourses.length > 0) {
                                if (
                                    this.getSubscribedLiveCourses.some(
                                        courseD => courseD.course_id === this.courseId
                                    )
                                ) {
                                    this.isSubscribed = true;
                                }
                            }
                        } else {
                            if (this.getSubscribedCourses.length > 0) {
                                if (
                                    this.getSubscribedCourses.some(
                                        courseD => courseD.course_id === this.courseId
                                    )
                                ) {
                                    this.isSubscribed = true;
                                }
                            }
                        }
                    }
                } else {
                    this.isSubscribed = false;
                }
            },
            setVideoUrl() {
                if (this.isSubscribed || this.courseData.price === 0) {
                    this.videoUrl = `https://studiov2.lyceum.one/webrtc/?room=${
                        this.courseData.room_number
                        }`;
                    this.showPlayList = false;
                } else {
                    this.videoUrl = this.courseData.videos[0].video_url;
                }
            },
            goToEdit() {
                this.$router.push({
                    path: "/add_course",
                    query: {
                        courseId: this.courseData.course_id
                    }
                });
            }
        },
        watch: {
            isAuthenticated() {
                if (this.isAuthenticated) {
                    this.getReview();
                }
            },
            $route() {
                this.initialFunction();
            },
            getCourseStatus() {
                console.log("in getCourses", this.getCourseStatus);
                this.setIsSubscribed();
                this.$nextTick(() => {
                    if (this.isLiveCourse) {
                        this.setVideoUrl();
                    }
                });
            },
            getRedirectToSubscription() {
                if (this.isAuthenticated) {
                    this.$router.push({
                        name: "course_subscription",
                        path: "/course_subscription"
                    });
                }
            },
            noResult(){
                commonFunctions.ToggleNoScroll();
            }
        }
    };
</script>

<style></style>
